const translations = {
  // ─── Navigation ────────────────────────────────────────
  "nav.home": {
    en: "Home",
    fr: "Accueil",
  },
  "nav.features": {
    en: "Features",
    fr: "Fonctionnalités",
  },
  "nav.pricing": {
    en: "Pricing",
    fr: "Tarifs",
  },
  "nav.support": {
    en: "Support",
    fr: "Support",
  },
  "nav.signUp": {
    en: "Sign Up",
    fr: "S'inscrire",
  },
  "nav.signIn": {
    en: "Sign In",
    fr: "Se connecter",
  },

  // ─── Hero / Baseline ──────────────────────────────────
  "hero.title": {
    en: "Never lose track of your UX insights again.",
    fr: "Ne perdez plus jamais la trace de vos insights UX",
  },
  "hero.subtitle": {
    en: "Create your living library of personas and products. Organize, share, leverage, and archive your UX insights, all in one place.",
    fr: "Créez votre bibliothèque de personas et produits vivante. Organisez, partagez, exploitez et archivez vos insights UX, tout en un seul endroit.",
  },
  "hero.aria": {
    en: "Hero",
    fr: "Accroche",
  },
  "hero.signInAria": {
    en: "Get started with Bibliona for free",
    fr: "Commencer gratuitement avec Bibliona",
  },
  "hero.signIn": {
    en: "Get started - it's free",
    fr: "Commencer gratuitement",
  },

  // ─── Many Section ─────────────────────────────────────
  "many.aria": {
    en: "Why use Bibliona",
    fr: "Pourquoi utiliser Bibliona",
  },
  "many.title.prefix": {
    en: "Do you work on many",
    fr: "Vous travaillez sur de nombreux",
  },
  "many.title.personas": {
    en: "personas",
    fr: "personas",
  },
  "many.title.and": {
    en: "and",
    fr: "et",
  },
  "many.title.products": {
    en: "products?",
    fr: "produits ?",
  },
  "many.point1.title": {
    en: "Never miss a key insight",
    fr: "Ne manquez plus aucun insight clé",
  },
  "many.point1.desc": {
    en: "Capture and organize every finding so no user pain point falls through the cracks.",
    fr: "Enregistrez et organisez chaque insight pour qu'aucun pain point utilisateur ne passe entre les mailles.",
  },
  "many.point2.title": {
    en: "One place for all your research",
    fr: "Toute votre recherche au même endroit",
  },
  "many.point2.desc": {
    en: "Stop digging through scattered documents. Find what you need in seconds.",
    fr: "Arrêtez de fouiller dans des documents éparpillés. Trouvez ce qu'il vous faut en quelques secondes.",
  },
  "many.point3.title": {
    en: "Collaborate without friction",
    fr: "Collaborez sans friction",
  },
  "many.point3.desc": {
    en: "Share insights with your team instantly. Collaborations and handovers become effortless.",
    fr: "Partagez vos insights instantanément. La collaboration et les onboardings deviennent un jeu d'enfant.",
  },

  // ─── Features Section ─────────────────────────────────
  "features.title": {
    en: "Features",
    fr: "Fonctionnalités",
  },
  "features.aria.section": {
    en: "Product features",
    fr: "Fonctionnalités du produit",
  },
  "features.aria.list": {
    en: "Features list",
    fr: "Liste des fonctionnalités",
  },
  "features.aria.slides": {
    en: "Feature slides",
    fr: "Diaporama des fonctionnalités",
  },
  "features.slide1.title": {
    en: "Your personas and products, beautifully organized",
    fr: "Vos personas et produits, parfaitement organisés",
  },
  "features.slide1.alt": {
    en: "Bibliona home screen showing persona and product library management",
    fr: "Écran d'accueil Bibliona montrant la gestion de bibliothèque de personas et produits",
  },
  "features.slide2.title": {
    en: "Every insight at your fingertips",
    fr: "Chaque insight à portée de main",
  },
  "features.slide2.alt": {
    en: "Bibliona insights list view for tracking UX research findings",
    fr: "Vue liste des enseignements Bibliona pour suivre les résultats de recherche UX",
  },
  "features.slide3.title": {
    en: "Keep your library clean and up to date",
    fr: "Gardez votre bibliothèque à jour",
  },
  "features.slide3.alt": {
    en: "Bibliona archive feature for managing outdated UX insights",
    fr: "Fonctionnalité d'archivage Bibliona pour gérer les connaissances UX obsolètes",
  },
  "features.slide4.title": {
    en: "Share with your team in one click",
    fr: "Partagez avec votre équipe en un clic",
  },
  "features.slide4.alt": {
    en: "Bibliona sharing and collaboration features for UX teams",
    fr: "Fonctionnalités de partage et collaboration Bibliona pour les équipes UX",
  },

  // ─── Call to Action ───────────────────────────────────
  "cta.aria": {
    en: "Get started with Bibliona",
    fr: "Commencer avec Bibliona",
  },
  "cta.title": {
    en: "Ready to organize your UX research?",
    fr: "Prêt à structurer votre recherche UX ?",
  },
  "cta.planPrefix": {
    en: "Start with the ",
    fr: "Commencez avec l'offre ",
  },
  "cta.free": {
    en: "free plan",
    fr: "gratuite",
  },
  "cta.startFree": {
    en: "Create My Library — Free",
    fr: "Créer ma bibliothèque — Gratuit",
  },
  "cta.seePricing": {
    en: "See pricing",
    fr: "Voir les tarifs",
  },

  // ─── Footer ───────────────────────────────────────────
  "footer.description": {
    en: "Helping UX teams organize and share their research, one insight at a time.",
    fr: "Aidons les équipes UX à organiser et partager leurs recherches, un insight à la fois.",
  },
  "footer.rights": {
    en: "All rights reserved.",
    fr: "Tous droits réservés.",
  },
  "footer.product": {
    en: "Product",
    fr: "Produit",
  },
  "footer.resources": {
    en: "Resources",
    fr: "Ressources",
  },
  "footer.aria": {
    en: "Footer navigation",
    fr: "Navigation du pied de page",
  },

  // ─── Pricing Page ─────────────────────────────────────
  "pricing.title": {
    en: "Pricing",
    fr: "Tarifs",
  },
  "pricing.aria": {
    en: "Pricing plans",
    fr: "Offres tarifaires",
  },
  "pricing.basic": {
    en: "Basic",
    fr: "Basique",
  },
  "pricing.free": {
    en: "Free",
    fr: "Gratuit",
  },
  "pricing.includes": {
    en: "Includes:",
    fr: "Inclus :",
  },
  "pricing.unlimitedProducts": {
    en: "Unlimited Products",
    fr: "Produits illimités",
  },
  "pricing.unlimitedPersonas": {
    en: "Unlimited Personas",
    fr: "Personas illimités",
  },
  "pricing.unlimitedExperiences": {
    en: "Unlimited Experiences",
    fr: "Expériences illimitées",
  },
  "pricing.pro": {
    en: "Pro",
    fr: "Pro",
  },
  "pricing.perMonth": {
    en: "/month",
    fr: "/mois",
  },
  "pricing.select": {
    en: "Select",
    fr: "Choisir",
  },
  "pricing.sharingFeatures": {
    en: "Sharing and collaboration features",
    fr: "Fonctionnalités de partage et collaboration",
  },
  "pricing.enterprise": {
    en: "Enterprise",
    fr: "Entreprise",
  },
  "pricing.perUserMonth": {
    en: "/user/month",
    fr: "/utilisateur/mois",
  },
  "pricing.libraryAccess": {
    en: "Library of Personas and Products accessible to any collaborators",
    fr: "Bibliothèque de personas et produits accessible à tous les collaborateurs",
  },
  "pricing.commonBilling": {
    en: "Common Billing",
    fr: "Facturation commune",
  },
  "pricing.seeFeatures": {
    en: "See features",
    fr: "Voir les fonctionnalités",
  },
  "pricing.contactUs": {
    en: "Contact Us",
    fr: "Nous contacter",
  },
  "pricing.basicAria": {
    en: "Sign in to the free Basic plan",
    fr: "Se connecter à l'offre Basique gratuite",
  },
  "pricing.proAria": {
    en: "Select the Pro plan at $1.99 per month",
    fr: "Choisir l'offre Pro à 1,99 $/mois",
  },
  "pricing.enterpriseAria": {
    en: "Select the Enterprise plan at $19.99 per user per month",
    fr: "Choisir l'offre Entreprise à 19,99 $/utilisateur/mois",
  },
  "pricing.additionalNav": {
    en: "Additional navigation",
    fr: "Navigation complémentaire",
  },

  // ─── 404 Page ─────────────────────────────────────────
  "notFound.title": {
    en: "404 - Page Not Found",
    fr: "404 - Page non trouvée",
  },
  "notFound.description": {
    en: "The page you're looking for no longer exists or has been moved. Try going back or explore our other sections to find what you need.",
    fr: "La page que vous recherchez n'existe plus ou a été déplacée. Essayez de revenir en arrière ou explorez nos autres sections pour trouver ce que vous cherchez.",
  },
  "notFound.goBack": {
    en: "Go Back to Home Page",
    fr: "Retour à l'accueil",
  },

  // ─── SEO ──────────────────────────────────────────────
  "seo.defaultTitle": {
    en: "Bibliona - Persona & Product Library for UX Designers",
    fr: "Bibliona - Bibliothèque de personas et produits pour les UX Designers",
  },
  "seo.defaultDescription": {
    en: "Never lose track of your UX insights again. Build your persona and product library to organize, share, and act on your research — all in one place. Free to start.",
    fr: "Ne perdez plus jamais la trace de vos insights UX. Créez votre bibliothèque de personas et produits pour organiser, partager et exploiter vos recherches — au même endroit. Gratuit pour commencer.",
  },
  "seo.home.description": {
    en: "Never lose track of your UX insights again. Build your persona and product library to organize, share, and act on your research — all in one place. Free to start.",
    fr: "Ne perdez plus jamais la trace de vos insights UX. Créez votre bibliothèque de personas et produits pour organiser, partager et exploiter vos recherches — au même endroit. Gratuit pour commencer.",
  },
  "seo.features.title": {
    en: "Features - Persona & Product Management Tool",
    fr: "Fonctionnalités - Outil de gestion de personas et produits",
  },
  "seo.features.description": {
    en: "Discover Bibliona's features: create persona and product libraries, list and archive your UX insights, and share and collaborate with your team seamlessly.",
    fr: "Découvrez les fonctionnalités de Bibliona : créez des bibliothèques de personas et produits, listez et archivez vos connaissances UX, et collaborez facilement avec votre équipe.",
  },
  "seo.pricing.title": {
    en: "Pricing - Free & Pro Plans for UX Teams",
    fr: "Tarifs - Offres gratuites et Pro pour les équipes UX",
  },
  "seo.pricing.description": {
    en: "Start free with unlimited personas and products. Upgrade to Pro for collaboration features at $1.99/month, or Enterprise for team management at $19.99/user/month.",
    fr: "Commencez gratuitement avec des personas et produits illimités. Passez au Pro pour les fonctionnalités de collaboration à 1,99 $/mois, ou Entreprise pour la gestion d'équipe à 19,99 $/utilisateur/mois.",
  },
  "seo.notFound.title": {
    en: "Page Not Found",
    fr: "Page non trouvée",
  },
  "seo.notFound.description": {
    en: "The page you're looking for no longer exists or has been moved.",
    fr: "La page que vous recherchez n'existe plus ou a été déplacée.",
  },

  // ─── JSON-LD ──────────────────────────────────────────
  "jsonld.home.description": {
    en: "Persona and product library for UX designers and user researchers. Organize, share, and collaborate on your research insights.",
    fr: "Bibliothèque de personas et produits pour les UX designers et chercheurs utilisateurs. Organisez, partagez et collaborez sur vos connaissances.",
  },
  "jsonld.home.basic.description": {
    en: "Free plan with unlimited personas, products, and experiences",
    fr: "Offre gratuite avec personas, produits et expériences illimités",
  },
  "jsonld.home.pro.description": {
    en: "Pro plan with sharing and collaboration features",
    fr: "Offre Pro avec fonctionnalités de partage et collaboration",
  },
  "jsonld.pricing.name": {
    en: "Bibliona Pricing",
    fr: "Tarifs Bibliona",
  },
  "jsonld.pricing.description": {
    en: "Choose the right Bibliona plan for your UX research needs. Free, Pro, and Enterprise options available.",
    fr: "Choisissez l'offre Bibliona adaptée à vos besoins. Options gratuite, Pro et Entreprise disponibles.",
  },
  "jsonld.pricing.basic.description": {
    en: "Free plan with unlimited personas, products, and experiences",
    fr: "Offre gratuite avec personas, produits et expériences illimités",
  },
  "jsonld.pricing.pro.description": {
    en: "Sharing and collaboration features with unlimited resources",
    fr: "Fonctionnalités de partage et collaboration avec ressources illimitées",
  },
  "jsonld.pricing.enterprise.description": {
    en: "Team library, collaboration, common billing, and unlimited resources",
    fr: "Bibliothèque d'équipe, collaboration, facturation commune et ressources illimitées",
  },

  // ─── Persona alt text ─────────────────────────────────
  "personas.alt": {
    en: "Example persona profile",
    fr: "Exemple de profil persona",
  },
  "personas.mainAlt": {
    en: "Bibliona persona and product library dashboard preview",
    fr: "Aperçu du tableau de bord Bibliona de bibliothèque de personas et produits",
  },

  // ─── FAQ ──────────────────────────────────────────────
  "faq.aria": {
    en: "Frequently asked questions",
    fr: "Questions fréquentes",
  },
  "faq.title": {
    en: "Frequently asked questions",
    fr: "Questions fréquentes",
  },
  "faq.q1": {
    en: "What is Bibliona?",
    fr: "Qu'est-ce que Bibliona ?",
  },
  "faq.q1.answer": {
    en: "Bibliona is a library to organize, centralize, and share your personas, products, and UX insights. It helps you turn your user research into a structured, reusable knowledge base.",
    fr: "Bibliona est une bibliothèque pour organiser, centraliser et partager vos personas, produits et insights UX. Elle permet de transformer vos recherches utilisateurs en une base structurée et réutilisable.",
  },
  "faq.q2": {
    en: "Who is Bibliona for?",
    fr: "À qui s'adresse Bibliona ?",
  },
  "faq.q2.answer": {
    en: "Bibliona is designed for UX designers, product designers, researchers, and product teams who work with personas, user journeys, or UX studies.",
    fr: "Bibliona est conçu pour les UX designers, product designers, researchers et équipes produit qui travaillent avec des personas, des parcours utilisateurs ou des études UX.",
  },
  "faq.q3": {
    en: "Is it a documentation tool or a research tool?",
    fr: "Est-ce un outil de documentation ou un outil de recherche ?",
  },
  "faq.q3.answer": {
    en: "Bibliona doesn't replace your research tools: it helps you structure and leverage what you've already learned, so insights from user research reports don't get lost or forgotten over time.",
    fr: "Bibliona ne remplace pas vos outils de recherche : il vous aide à structurer et exploiter ce que vous avez déjà appris, pour que les insights de vos rapports de recherche utilisateur ne se perdent pas et ne tombent pas dans l'oubli avec le temps.",
  },
  "faq.q4": {
    en: "How is it different from Notion, FigJam, or Google Docs?",
    fr: "Quelle est la différence avec un Notion, FigJam ou Google Docs ?",
  },
  "faq.q4.answer": {
    en: "Unlike general-purpose tools, Bibliona is built specifically for UX knowledge. Your personas, products, and insights are not just stored — they are structured, connected, and kept alive as your research evolves.",
    fr: "Contrairement aux outils généralistes, Bibliona est conçu spécifiquement pour les connaissances UX. Vos personas, produits et insights ne sont pas seulement stockés — ils sont structurés, reliés entre eux et maintenus vivants au fil de l'évolution de vos recherches.",
  },
  "faq.q5": {
    en: "Is Bibliona free?",
    fr: "Est-ce que Bibliona est gratuit ?",
  },
  "faq.q5.answer": {
    en: "Yes. The Basic plan is free and lets you build a complete library of personas, products, and experiences.",
    fr: "Oui. Le plan Basic est gratuit et permet de créer une bibliothèque complète de personas, produits et expériences.",
  },
  "faq.q6": {
    en: "Why upgrade to the Pro plan?",
    fr: "Pourquoi passer au plan Pro ?",
  },
  "faq.q6.answer": {
    en: "The Pro plan adds sharing and collaboration features so your team can work more efficiently — ideal for studios, startups, and product teams.",
    fr: "Le plan Pro ajoute les fonctionnalités de partage et de collaboration pour travailler en équipe plus efficacement (idéal pour les studios, startups et équipes produit).",
  },
  "faq.q7": {
    en: "Can I collaborate with my team?",
    fr: "Est-ce que je peux collaborer avec mon équipe ?",
  },
  "faq.q7.answer": {
    en: "Yes, with the Pro plan. You can share your libraries and work together on the same UX resources.",
    fr: "Oui, avec le plan Pro. Vous pouvez partager vos bibliothèques et travailler à plusieurs sur les mêmes ressources UX.",
  },
  "faq.q8": {
    en: "Is my data private?",
    fr: "Est-ce que mes données sont privées ?",
  },
  "faq.q8.answer": {
    en: "Yes. Your data is not exploited and remains under your control. Bibliona is built for professional, secure use.",
    fr: "Oui. Vos données ne sont pas exploitées et restent sous votre contrôle. Bibliona est conçu pour un usage professionnel et sécurisé.",
  },
  "faq.q9": {
    en: "Is Bibliona hard to use?",
    fr: "Est-ce que Bibliona est compliqué à utiliser ?",
  },
  "faq.q9.answer": {
    en: "No. The goal is to reduce complexity: you can organize your insights in minutes without heavy setup.",
    fr: "Non. L'objectif est justement de réduire la complexité : vous organisez vos insights en quelques minutes sans configuration lourde.",
  },
  "faq.q10": {
    en: "Can I import my existing personas?",
    fr: "Puis-je importer mes personas existants ?",
  },
  "faq.q10.answer": {
    en: "Bibliona is designed to gradually integrate your existing content, without depending on a specific format. The idea is to let you structure your knowledge base over time.",
    fr: "Bibliona est conçu pour intégrer progressivement vos contenus existants, mais sans dépendance à un format spécifique. L'idée est de vous laisser structurer votre base au fur et à mesure.",
  },
  "faq.q11": {
    en: "Does Bibliona replace my design tool?",
    fr: "Est-ce que Bibliona remplace mon outil de design ?",
  },
  "faq.q11.answer": {
    en: "No. Bibliona complements your tools (Figma, Notion, etc.) by serving as a layer for structuring UX knowledge.",
    fr: "Non. Bibliona complète vos outils (Figma, Notion, etc.) en servant de couche de structuration des connaissances UX.",
  },
  "faq.q12": {
    en: "How do I get started?",
    fr: "Comment commencer ?",
  },
  "faq.q12.answer": {
    en: "Just create an account and start adding your first personas or products. No complex setup required.",
    fr: "Il suffit de créer un compte et de commencer à ajouter vos premiers personas ou produits. Aucun setup complexe requis.",
  },

  // ─── Breadcrumbs ──────────────────────────────────────
  "breadcrumbs.aria": {
    en: "Breadcrumb",
    fr: "Fil d'Ariane",
  },

  // ─── Open navigation ─────────────────────────────────
  "nav.openMenu": {
    en: "Open navigation menu",
    fr: "Ouvrir le menu de navigation",
  },
  "nav.mainAria": {
    en: "Main navigation",
    fr: "Navigation principale",
  },
};

export default translations;
